<template>
  <div class="search-criteria-box">
  <h4 class="tit-search-type is-bgc-red400">高さ</h4>
  <!-- <img src="/images/cmn/ico-height.png" class="img-fluid mx-auto" alt="" width="300" height="200"> -->
  <div class="search-radio-set">
    <template v-for="option in options">
      <input type="radio"
      :name="name"
      :id="`label2-${option.id}`"
      :key="`radio2-${option.id}`"
      :value="option.data"
      @change="updateValue(option.data)"
      v-bind:disabled="flag[option.id]==false"
      >
      <label :key="`label2-${option.id}`" :for="`label2-${option.id}`" v-html="option.value"></label>
    </template>
  </div>
</div>
</template>
<script>
export default {
  props: {
    value: {},
    options: { type: Array },
    name: { type: String },
    flag: { type: Object },
  },
  methods: {
    // updateValue: function(value, flag) {
    //   this.$emit('HeightFlag', flag);
    //   this.$emit("input", value);
    // }
    updateValue: function(value) {
      this.$emit("input", value);
    }
  }
}
</script>